import React, { useState } from 'react'

export type AppErrorDispatchType = React.Dispatch<React.SetStateAction<boolean>>

const AppErrorState = React.createContext<boolean>(false)
const AppErrorDispatch = React.createContext<AppErrorDispatchType | null>(null)

/**
 * a Context to capture app-level errors across all child Components
 */
const AppErrorProvider: React.FC = ({ children }) => {
  const [hasAppError, setHasAppError] = useState<boolean>(false)

  return (
    <AppErrorState.Provider value={hasAppError}>
      <AppErrorDispatch.Provider value={setHasAppError}>
        {children}
      </AppErrorDispatch.Provider>
    </AppErrorState.Provider>
  )
}

function useAppErrorState() {
  const context = React.useContext(AppErrorState)
  return context
}

function useAppErrorDispatch() {
  const context = React.useContext(AppErrorDispatch)
  return context
}

export { useAppErrorState, useAppErrorDispatch, AppErrorProvider }
